class LoadingStep {
    constructor() {
    }
    init() {
        const listSteps = document.querySelector('.vg-joining-process__list-steps');
        if (listSteps) {
            listSteps.classList.add('vg-joining-process__list-steps--loading');
        }
    }
    remove() {
        const listSteps = document.querySelector('.vg-joining-process__list-steps');
        if (listSteps) {
            listSteps.classList.remove('vg-joining-process__list-steps--loading');
        }
    }
}
export { LoadingStep };